import React from 'react'

import { DataQuoteStateType } from '../typesCollapseQuote';
import * as S from './styles';
import ColumnLabel from '@/main/components/common/columnLabel/columnLabel';
import { getGuidScreenByRoute, getTranslateByKey, isNullUndefined } from '@/main/services/utils';
import KogThreeDotsQuote from '@/main/components/shared/threeDotsQuote';
import { ProcurementStatusEnum } from '@/main/services/enum/StatusProcurement';
import { RoutesConstants } from '@/main/routes/routesConstants';
import { RefreshQuoteByGetItemsType } from '@/main/components/shared/boxCart/components/types';
import { CartState } from '@/main/store/cart';
import CopyToClipboardText from '@/main/components/shared/copyToClipboardText/copyToClipboardText';

interface IHeaderCollapseQuoteProps {
  dataQuote: DataQuoteStateType;
}
function HeaderCollapseQuote({
  dataQuote
}: IHeaderCollapseQuoteProps) {

  if (isNullUndefined(dataQuote)) return null;


  return (
    <S.Container>
      <ColumnLabel
        label={getTranslateByKey('information.vin')}
        content={
          <CopyToClipboardText
            label={getTranslateByKey('information.vin')}
            valueToCopy={dataQuote.vehicleVIN ? dataQuote.vehicleVIN : ''}>
            {dataQuote.vehicleVIN}
          </CopyToClipboardText>}
      />
    </S.Container>
  )
}

export default HeaderCollapseQuote